var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8095 22.2857L12.4762 16.8571L8.09524 13.3333H13.5238L15.2381 8L16.9524 13.3333H22.381L17.9524 16.8571L19.619 22.2857L15.2381 18.9048L10.8095 22.2857ZM3.80952 40V25.2857C2.60317 23.9524 1.66667 22.4286 1 20.7143C0.333333 19 0 17.1746 0 15.2381C0 10.9841 1.47619 7.38095 4.42857 4.42857C7.38095 1.47619 10.9841 0 15.2381 0C19.4921 0 23.0952 1.47619 26.0476 4.42857C29 7.38095 30.4762 10.9841 30.4762 15.2381C30.4762 17.1746 30.1429 19 29.4762 20.7143C28.8095 22.4286 27.873 23.9524 26.6667 25.2857V40L15.2381 36.1905L3.80952 40ZM15.2381 26.6667C18.4127 26.6667 21.1111 25.5556 23.3333 23.3333C25.5556 21.1111 26.6667 18.4127 26.6667 15.2381C26.6667 12.0635 25.5556 9.36508 23.3333 7.14286C21.1111 4.92063 18.4127 3.80952 15.2381 3.80952C12.0635 3.80952 9.36508 4.92063 7.14286 7.14286C4.92063 9.36508 3.80952 12.0635 3.80952 15.2381C3.80952 18.4127 4.92063 21.1111 7.14286 23.3333C9.36508 25.5556 12.0635 26.6667 15.2381 26.6667ZM7.61905 34.3333L15.2381 32.381L22.8571 34.3333V28.4286C21.746 29.0635 20.5476 29.5635 19.2619 29.9286C17.9762 30.2937 16.6349 30.4762 15.2381 30.4762C13.8413 30.4762 12.5 30.2937 11.2143 29.9286C9.92857 29.5635 8.73016 29.0635 7.61905 28.4286V34.3333Z",
    fill: "#F58220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHs);
export default __webpack_public_path__ + "static/media/HS.2d129f0dbd33c413fecbcaf058cf94c8.svg";
export { ForwardRef as ReactComponent };